<template>
  <section class="winners-2019-qualifications-winners-section">
    <div class="container">
      <h2 class="winners-2019-title">Квалификации</h2>
      <div class="grid-box">
        <div class="winners-2019-qualifications-winners-section__list row">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="col-12 col-lg-6"
          >
            <Winners2019QualificationWinnersCard
              :number="index + 1"
              :prize_1="item.prize_1"
              :winner_1="item.winner_1"
              :prize_2="item.prize_2"
              :winner_2="item.winner_2"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Winners2019QualificationWinnersCard from "./Winners2019QualificationWinnersCard";
import { qualificationWinners } from "@/data/winners";

export default {
  name: "Winners2019QualificationsWinnersSection",
  components: {
    Winners2019QualificationWinnersCard
  },
  data: () => ({
    items: Object.freeze(qualificationWinners)
  })
};
</script>

<style lang="scss">
.winners-2019-qualifications-winners-section {
  &__list {
    background: url("~@/assets/img/prizes/prize-bg-2.png") 50% 35% no-repeat;
    > [class*="col-"] {
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }
}
</style>
